import { createContext, useContext, useEffect } from 'react';
export const ObjectsActionContextReact = createContext(undefined);
export function useObjectsActionContext() {
    const ctx = useContext(ObjectsActionContextReact);
    if (!ctx) {
        throw new Error("You cannot use useActionContext outside an ActionProvider");
    }
    return ctx;
}
export function useObjectsActionCallback(name, cb) {
    const ctx = useObjectsActionContext();
    useEffect(() => {
        return ctx.registerCallback(name, cb);
    }, [ctx, name, cb]);
    return ctx;
}
export function useStartWorkflowCallback(cb) {
    const ctx = useObjectsActionContext();
    useEffect(() => {
        ctx.startWorkflow = cb;
        return () => {
            ctx.startWorkflow = undefined;
        };
    }, [cb, ctx]);
    return ctx;
}
//# sourceMappingURL=ObjectsActionHooks.js.map